import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';

// ----------------------------------------------------------------------

export default function TablePaginationApiBased({
  dense,
  onChangeDense,
  rowsPerPageOptions = [ 5, 10, 25 ],
  sx,
  paginationLinks = { links: [] },
  onPageChange,
  ...other
}) {
  const currentPage = paginationLinks.current_page || 1;
  const lastPage = paginationLinks.last_page || 1;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage && page !== currentPage) {
      if (onPageChange) onPageChange(page);
    }
  };

  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < lastPage ? currentPage + 1 : null;

  return (
    <Box sx={ { position: 'relative', ...sx } }>
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={ { mb: 2 } }>
        <Box>
          {/* Previous Page Button */ }
          <Button
            variant="outlined"
            onClick={ () => handlePageChange(prevPage) }
            disabled={ !prevPage }
          >
            &laquo; Previous
          </Button>

          {/* Page Numbers */ }
          { paginationLinks.links?.length > 0 ? (
            paginationLinks.links
              .filter(
                (link) =>
                  link.label !== "&laquo; Previous" && link.label !== "Next &raquo;"
              )
              .map((link) => (
                <Button
                  key={ link.label }
                  variant={ link.active ? 'contained' : 'outlined' }
                  onClick={ () => handlePageChange(Number(link.label)) }
                  sx={ { mx: 1 } }
                >
                  { link.label }
                </Button>
              ))
          ) : (
            <Button variant="outlined" disabled>
              No Pages Available
            </Button>
          ) }

          {/* Next Page Button */ }
          <Button
            variant="outlined"
            onClick={ () => handlePageChange(nextPage) }
            disabled={ !nextPage }
          >
            Next &raquo;
          </Button>
        </Box>

        {/* Dense Toggle */ }
        { onChangeDense && (
          <FormControlLabel
            label="Dense"
            control={ <Switch checked={ dense } onChange={ onChangeDense } /> }
            sx={ {
              pl: 2,
              py: 1.5,
              top: 0,
              position: {
                sm: 'absolute',
              },
            } }
          />
        ) }
      </Box>
    </Box>
  );
}

TablePaginationApiBased.propTypes = {
  dense: PropTypes.bool,
  onChangeDense: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  sx: PropTypes.object,
  paginationLinks: PropTypes.shape({
    links: PropTypes.array,
    prev_page_url: PropTypes.string,
    next_page_url: PropTypes.string,
    last_page: PropTypes.number,
    current_page: PropTypes.number,
  }).isRequired,
  onPageChange: PropTypes.func,
};
